<template>
  <div class="search-outer" ref="searchOuter">
    <div ref="searchRef"
      :style="searchStyle"
      class="search" 
      :class="{'is-float': isFloating}">
      <div class="search-left">
        <slot></slot>
      </div>
      <div class="search-right">
        <el-button v-if="isShowExpand" 
          size="small" 
          type="text" 
          @click="showMore = !showMore">
          {{showMore ? '收起' : '展开'}}
        </el-button>
        <slot name="right"></slot>
      </div>
    </div>
  </div>
</template>

<script>
const SINGLE_HEIGHT = 34;
export default {
  name: 'SearchBox',
  props: {
    // 是否默认展开
    defaultExpand: {
      type: Boolean,
      default: false
    },
    // 是否浮动模式
    isFloating: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      // 是否显示展开，收起按钮
      isShowExpand: false,
      // 展开收起标志
      showMore: false,
      // 展示是增加的高度
      addedHeight: 0,
      // 父容器宽度
      containerWidth: 0
    }
  },
  computed: {
    searchScrollHeight() {
      return this.$refs.searchRef.scrollHeight;
    },
    searchScrollWidth() {
      return this.$refs.searchRef.scrollWidth;
    },
    searchStyle() {
      return {
        height: this.showMore 
          ? `${this.searchScrollHeight}px` 
          : `${SINGLE_HEIGHT}px`
      }
    }
  },
  watch: {
  },
  methods: {
    checkShowExpand() {
      // 获取父容器宽度
      this.getContainerWidth();
      // 使用父容器宽度而不是视口宽度
      this.isShowExpand = this.searchScrollHeight > SINGLE_HEIGHT 
        && this.searchScrollWidth > this.containerWidth - 50;
    },
    getContainerWidth() {
        // 在弹窗中，获取父容器宽度
        let parent = this.$refs.searchOuter;
        while (parent && !parent.classList.contains('el-dialog') && !parent.classList.contains('dialog-content')) {
          parent = parent.parentElement;
        }
        this.containerWidth = parent ? parent.clientWidth : this.$refs.searchOuter.clientWidth;
    },
    // 窗口大小变化时重新检查
    handleResize() {
      this.$nextTick(() => {
        this.checkShowExpand();
      });
    }
  },
  mounted() {
    this.checkShowExpand();
    if (this.defaultExpand) {
      this.showMore = true;
    }
    
  },
}
</script>

<style lang="stylus" scoped>
.search-outer
  box-sizing border-box
  position relative
  padding-top 5px
  min-height 36px
  color #606266
  background-color #ffffff
  border-radius 5px
.search
  display flex
  justify-content space-between
  padding 0 8px
  background-color #ffffff
  border-radius: 6px
  height 33px
  overflow hidden
  transition height ease-in .3s

  &-left
    flex 1
  &-right
    padding-top 2px

.is-float
  box-sizing border-box
  position absolute
  left 0
  right 0
  z-index 5

 .search-outer >>> .el-date-editor, >>> .el-select, >>> .el-input {
  width: 200px !important;
}
</style>